import React, { Component } from "react";
import propTypes from "prop-types";
import _, { cloneDeep, isFunction, remove, omit, isString } from "lodash";
import { Row, Col, Table, Space, Dropdown, Menu, Checkbox, Tooltip, Divider, Typography, Switch, Input, Button } from "antd";
import { BASE_GUTTER, BASE_MARGIN, BASE_PADDING, FULL_MENU_WIDTH, MIN_SCREEN_WIDTH } from "constants/Layout";
import { LoadingIcon, RightIcon, DownIcon, ResetFilterIcon,SelectColumnIcon, SearchIcon, CloseIcon, HelpIcon } from "./Icons";
import { withRouter } from "react-router-dom";
import makeCancellablePromise from "make-cancellable-promise";
import { getFilterProps,DEFAULT_PAGINATION, getDataIndex, setInitialDataAndGetOptionalColumns, MAX_DATA_ERROR_MSG, MAX_DATA_MSG, formatNumber, MakeDNDMenu } from "utils/tableUtils";
import { withGlobalFilterContext } from "contexts/GlobalFilterContext";
import { withUserPreferencesContext } from "contexts/UserPreferencesContext";
import FilterBar from "./FilterBar";
import { ShareIt } from "./ShareIt";
import { withGlobalUserListContext } from "contexts/GlobalUserListContext";
import { withGlobalSettingsContext } from 'contexts/GlobalSettingsContext'
import MultiSorting, { parseMultiSort } from "./MultiSorting";
import { getTemporarySessionStorage, setTemporarySessionStorage } from "utils/sessionFilterStoreUtil"
import Pagination from "./Pagination";
import { getErrorMessage } from "utils/errorUtil"
import classNames from "classnames";
import { withFeatureFlags } from "contexts/FeatureFlagContext";
import { parseURLSearch, updateURLSearch } from "utils/urlUtil";
/**
 * 
 * @props 
 * 
 * -  api: function to fetch table data
 * -  filtersApi: function to fetch table filters
 * -  search: wether to show searchBar above table or not
 * -  title: To show title above table
 * 
 * 
 * DO NOT USE SEARCH & TITLE PROP TOGATHER
 * IT WILL LEADS TO UI ISSUES
 */

class TableContainerEvolved extends Component{
    aqlTextAreaRef = React.createRef();
    static propTypes = {
        api: propTypes.func.isRequired,
        filtersApi: propTypes.func,
    }
    static defaultProps = {
        columns: [],
        showSizeChanger: true,
        ignoreFiltersOnReset: [],
        multiSort: false,
        paginationPosition: "bottomRight",
        showRestFilter: true,
        hideMultiSortButton: false
    }
    constructor(props){
        super(props);

        const { tableKey, userPreferencesContext } = props;
        // This will set the initial column view
        const { optionalColumns } = setInitialDataAndGetOptionalColumns(userPreferencesContext, tableKey, props.columns);
        
        const orderedOptionalColumns = userPreferencesContext.getColumnOrder(tableKey, optionalColumns);

        this.state = {
            optionalColumns: orderedOptionalColumns,
            filteredInfo: {},
            sortedInfo: {},
            globalSearch: "",
            dataSource: [],
            expandedValue: [],
            loading: true,
            totalElements: 0,
            ...parseURLSearch(props.location?.search),
            paginationComponentSize: props.paginationComponentSize,
            paginationObj: {},
            filtersValues: {},
            searchBoxText: '',
            additionalColumnSearchText: '',
            errorMessage: false
        }

        _.bindAll(
            this, 
            "onSearch",
            "onChangeTable",
            "onExternalPaginationChange",
            "updateColumns",
            "resetFilters",
            "handleSwitch",
            "onExpandRow",
            "onDragEnd",
            "getFilteredData",
            "updateTableChange",
            "onPageChange",
            "onAdditionalColumnSearch",
            "onOptionalColumnVisibilityChange",
            "applyAQL",
            "toggleAQL",
            "renderResetToDefault",
            "onResetAdditionalColumn"  
        );
        this.isSortAppliedOnNonExistingColumn = false;
        this.lastSearchAndSelectdCol = '';
    }
    getFilteredData() {
        if(!this.props.disableURLUpdate){
            return parseURLSearch(this.props.location.search)
        }else{
            const filterInfo = {...this.state.filteredInfo};
            if(!filterInfo.pagination){
                filterInfo.pagination = { ...DEFAULT_PAGINATION }
                if(this.props.defaultPageSize){
                    filterInfo.pagination.size = this.props.defaultPageSize;
                }
            }
            return filterInfo;
        }
    }
    updateTableChange(parsedUrl){
        if(!this.props.disableURLUpdate){
            updateURLSearch(this.props.history, parsedUrl);
        }else{
            this.setState({ filteredInfo:parsedUrl},()=>{
                this.fetchData();
            })
        }
    }

    getFilters() {
        const { noProductSubProductEnvFilter, ignoreFiltersOnReset } = this.props;
        const { filters } = this.getFilteredData();
        const _filters = {};
        if (noProductSubProductEnvFilter) {
            ignoreFiltersOnReset.push('environmentName', 'product', 'subProduct');
        }
        if (!_.isEmpty(ignoreFiltersOnReset)) {
            _.forEach(ignoreFiltersOnReset, (filterKey) => {
                _filters[filterKey] = filters[filterKey];
            });
        }
        return _filters;
    }
    resetFilters(){
        this.props.onResetFilters && this.props.onResetFilters();
        const pagination = {...DEFAULT_PAGINATION, sort: '' };
        if(this.props.defaultPageSize){
            pagination.size = this.props.defaultPageSize;
        }
        if(!this.props.disableURLUpdate){
        const urlChanged = updateURLSearch(this.props.history, {
            pagination,
            filters: this.getFilters(),
            query: "",
            savedSearch: {}
        });
    
        // if the url wasn't changed, then the change won't trigger
        // so fetch the data forcefully
        if(!urlChanged || _.isEmpty(this.props.location.search)){
            this.fetchData();
        }
    }else{
        this.updateTableChange({
            pagination,
            filters: this.getFilters(),
            query: "",
            savedSearch: {}
        })
    }
    }
    onSearch(e){
        this.setState({
            searchText: e?.target?.value || ""
        });
    }
    onChangeTable(paginationFromTable, filtersFromTable, sortFromTable, extra = {}){
        const { paginationObj } = this.state;
        const { useCustomPagination = false } = this.props;
        const { action } = extra;
        const {pagination, filters={}, query,savedSearch} = this.getFilteredData();

        const pageObjToUse = useCustomPagination ? paginationObj : paginationFromTable;

        pagination.page = pageObjToUse.current - 1;
        if(pagination.size !== pageObjToUse.pageSize || action === "filter" || _.isNaN(pagination.page)){
            pagination.page = 0;
        }
        pagination.size = pageObjToUse.pageSize;
        if (action === 'sort') {
            if(sortFromTable?.column && sortFromTable?.order){
                pagination.sort = `${sortFromTable.columnKey},${sortFromTable.order}`;
                this.isSortAppliedOnNonExistingColumn = false;
            } else if (this.props.multiSort && _.isArray(sortFromTable)) {
                const lastItem = _.last(sortFromTable);
                pagination.sort = `${lastItem.columnKey},${lastItem.order}`;
                this.isSortAppliedOnNonExistingColumn = false;
            } else if (!this.isSortAppliedOnNonExistingColumn) {
                // Empty sort only if sorting has been removed from table column
                pagination.sort = '';
            }
        }

        _.assign(filters, filtersFromTable);
        this.updateTableChange({
            pagination,
            filters,
            query,
            savedSearch
        })
    }
    onPageChange(paginationObj) {
        this.setState({
            paginationObj
        }, this.onChangeTable);
    }
    onExternalPaginationChange(current){
        
    }
    updateColumns(e){
        const { userPreferencesContext, tableKey } = this.props;
        const parsedUrl = this.getFilteredData();
        const activeOptionalColumns = userPreferencesContext.getActiveOptionalColumns(tableKey);
        const dataIndex = e.target["data-index"];
        const index = activeOptionalColumns.indexOf(dataIndex);
        let refreshNeeded = false;
        if(index > -1){
            if(!_.isEmpty(parsedUrl.filters) && parsedUrl.filters[dataIndex]){
                refreshNeeded = true;
                parsedUrl.filters[dataIndex] = null;
            }
        }
        userPreferencesContext.updateColumnPreference(e.target.checked, dataIndex, tableKey);
        setTimeout(() => {
            // Need to call it here as now the DOM element is not present for few milisecond on checking it.
            if (index === -1) {
                this.addHighlightToColumn(this.state.additionalColumnSearchText ? dataIndex : '');
            } else {
                this.addHighlightToColumn('');
            }
        }, 10);
        if(refreshNeeded){
           this.updateTableChange(parsedUrl);
        }
    }

    onDragEnd(result) {
        const { source, destination } = result;
  
        const { tableKey, userPreferencesContext } = this.props;
        userPreferencesContext.changeColumnSequence(tableKey, source, destination);
    }

    getActiveColumns() {
        const { globalSettings, columns, userPreferencesContext, tableKey } = this.props;
        const activeOptionalColumns = userPreferencesContext.getActiveOptionalColumns(tableKey);
        const activeColumns = [];
        const sortedColumns = _.sortBy(columns, (col, i) => { // sort the columns with the drag and drop optionsColumns
            const dataIndex = getDataIndex(col)
            const index = _.findIndex(activeOptionalColumns, o => o === dataIndex)
            return col.alwaysDisplay ? _.findIndex(columns, o => getDataIndex(o) === dataIndex) : (index !== -1 ? index : columns.length)
        })
        sortedColumns.forEach(col => {
            const dataIndex = getDataIndex(col)
            if (dataIndex && ( activeOptionalColumns.includes(dataIndex) || col.alwaysDisplay )) {
                let title = "";
                if (!isString(col.title) && col.title.props?.children?.length > 1) {
                    title = _.join(_.map(col.title.props.children, (child) => {
                        if (isString(child)) {
                            return child;
                        }
                        return globalSettings[child.props.name] || child.props.name;
                    }), " ");
                } else {
                    //for some title, dataIndex does not match in global settings such as armorcodeCategory
                    //need to match vocabulary name from col.title.props.name
                    title = isString(col.title) ? col.title : (globalSettings[col.title.props.name] || globalSettings[dataIndex] || dataIndex );
                }
                activeColumns.push({field: dataIndex, header: title.replace(/\s+/g,' ').trim()})
            }
        })
        return activeColumns;
    }

    onAdditionalColumnSearch(e) {
        this.setState({
            additionalColumnSearchText: e.target.value,
        });
    }

    onOptionalColumnVisibilityChange(visible) {
        if (visible) {
            // Reset the search filter
            this.setState({ additionalColumnSearchText: '' });
        } else {
            // Remove highlight on menu close
            this.addHighlightToColumn('');
        }
    }

    addHighlightToColumn(columnId) {
        // Remove previous highlight if selected
        if (this.lastSearchAndSelectdCol) {
            const lastSelected = this.columListRef.querySelector(`[data-rbd-draggable-id="${this.lastSearchAndSelectdCol}"]`);
            lastSelected?.classList.remove('highlight');
        }

        // Add highlight to current selection
        if (columnId) {
            const currentSelected = this.columListRef.querySelector(`[data-rbd-draggable-id="${columnId}"]`);
            currentSelected?.classList.add('highlight');
        }
        this.lastSearchAndSelectdCol = columnId;
    }

    onResetAdditionalColumn() {
        const { tableKey, userPreferencesContext } = this.props;

        if (userPreferencesContext.tablePreferences[tableKey]) {

            // deletes table preferences data 
            userPreferencesContext.deleteTablePreference(tableKey);
            userPreferencesContext.deleteTablePreference(tableKey, 'columnOrder');
            const { optionalColumns } = setInitialDataAndGetOptionalColumns(userPreferencesContext, tableKey, this.props.columns);
            const orderedOptionalColumns = userPreferencesContext.getColumnOrder(tableKey, optionalColumns);

            this.setState({
                optionalColumns: orderedOptionalColumns
            });
        }
    }

    renderResetToDefault() {
        return (
            <div className='m-t-sm' style={{marginLeft: 20, textDecoration: 'underline'}}><Typography.Link onClick={this.onResetAdditionalColumn}>Reset to Default</Typography.Link></div>
        );
    }

    renderColumnOptions(){
        const {additionalColumnSearchText} = this.state;
        let {optionalColumns} = this.state;
        const { columnsReorder = false, tableKey } = this.props;
        if(_.isEmpty(optionalColumns)){
            return null;
        }
        const activeOptionalColumns = this.props.userPreferencesContext.getActiveOptionalColumns(tableKey);
        if (additionalColumnSearchText) {
            optionalColumns = _.filter(optionalColumns, (col) => {
                return col.text.toLowerCase().includes(additionalColumnSearchText.toLowerCase());
            });
        }
        const selectedColumns = _.compact(activeOptionalColumns.map(columnKey => _.find(optionalColumns, { value: columnKey})));
        const notSelectedColumns = optionalColumns.filter(col => !activeOptionalColumns.includes(col.value));
        return (
            <Dropdown overlayClassName={'box-shadow table-column-options'} overlayStyle={{ maxHeight: 673, maxWidth: 210 }} trigger="click" placement="bottomRight" overlay={
                <>
                    <div className="column-search">
                        <Input
                            placeholder='Search'
                            value={additionalColumnSearchText}
                            onChange={this.onAdditionalColumnSearch} 
                            suffix={
                                <Tooltip placement='left' title="Column arrangement is disable while searching.">
                                    <HelpIcon />
                                </Tooltip>
                            }
                            allowClear
                            autoFocus={true}
                        />
                        {this.renderResetToDefault()}
                    </div>
                    <div ref={(ref) => this.columListRef = ref}>
                        {
                            columnsReorder ? (
                                <MakeDNDMenu selectedColumnOrder={selectedColumns} notSelectedColumnOrder={notSelectedColumns} activeOptionalColumns={activeOptionalColumns} onDragEnd={this.onDragEnd} updateColumns={this.updateColumns} disableDND={!!additionalColumnSearchText}  />
                            ) : (
                                <Menu className="p-xs p-b-0">
                                    {
                                        optionalColumns.map(c => (
                                            <div className="m-b-xs" key={c.value}>
                                                <Checkbox
                                                    data-index={c.value}
                                                    checked={activeOptionalColumns.indexOf(c.value) !== -1}
                                                    onChange={this.updateColumns}
                                                >
                                                    <span title={c.text}>{c.text}</span>
                                                </Checkbox>
                                            </div>
                                        )
                                        )
                                    }
                                </Menu>
                            )
                        }
                    </div>
                </>
            }
            onVisibleChange={this.onOptionalColumnVisibilityChange}
            >
                <Tooltip title="Additional columns" placement="topRight">
                    <SelectColumnIcon className="clickable m-r-xs"/>
                </Tooltip>
            </Dropdown>
        )
    }
    componentDidMount(){
        const {defaultSort, defaultFilter, searchKey, columns, storeSessionFilter, tableKey, defaultPageSize } = this.props;
        const {pagination = {}, filters, query, savedSearch} = this.getFilteredData();
        
        const sessionStorageData = tableKey ? (getTemporarySessionStorage(tableKey) || {}) : {};
        const temporaryFilter = storeSessionFilter && sessionStorageData.filters;
        this.fetchFilters();
        if(((_.has(defaultSort, "sortColumn") && _.has(defaultSort, "sortOrder")) || _.isString(defaultSort)) && !_.has(pagination, 'sort') && _.isEmpty(query)){
            const filterData =  _.isEmpty(filters) ? ( _.isObject(temporaryFilter) && !_.isEmpty(temporaryFilter) ? temporaryFilter : defaultFilter ) : filters;
            pagination.sort = _.isString(defaultSort) ? defaultSort : `${defaultSort.sortColumn},${defaultSort.sortOrder}`;
            if (sessionStorageData.pageSize) {
                pagination.size = sessionStorageData.pageSize;
            } else if(defaultPageSize){
                pagination.size = defaultPageSize;
            }
            this.updateTableChange({
                pagination,
                filters:filterData,
                query,
                savedSearch
            });
        } else {
            this.fetchData();
        }

        // The boolean will be true if sorting is applied on non table column.
        if (pagination.sort) {
            const sortColumn = pagination.sort.split(',')[0];
            this.isSortAppliedOnNonExistingColumn = !_.some(columns, (column) => getDataIndex(column) === sortColumn);
        }

        if(typeof this.props.tableRef === "function"){
            this.props.tableRef({
                refresh: () => {
                    this.fetchData();
                },
                refreshFilters: () => {
                    this.fetchFilters();
                },
                resetFilters:()=>{
                    this.resetFilters();
                },
                getActiveColumns: () => {
                    return this.getActiveColumns();
                },
                getSortEnableActiveColumns: () => this.getSortEnableActiveColumns()
            });
        }
        if(searchKey) {
            this.setState({searchBoxText: filters[searchKey]})
        }
    }
    isSearchChanged(prevProps){
        const {location: {search} = {}, searchKey} = this.props;
        const { pagination, filters, query } = parseURLSearch(search)
        const { pagination: prevPagination, filters: prevFilters, query: prevQuery } = parseURLSearch(prevProps.location?.search)
        const omittedFilters = _.omitBy(filters, (value) => _.isArray(value) && value.length === 0);
        const omittedPrevFilters = _.omitBy(prevFilters, (value) => _.isArray(value) && value.length === 0);
        if((searchKey && !_.isEqual(omittedFilters, omittedPrevFilters)) || !_.isEqual(query, prevQuery)) {
            const obj = { query };
            if (searchKey) {
                obj.searchBoxText = omittedFilters[searchKey];
            }
            this.setState(obj)
        }
        return !_.isEqual(pagination, prevPagination) || !_.isEqual(omittedFilters, omittedPrevFilters) || query !== prevQuery;
    }
    componentDidUpdate(prevProps){
        const {location: {search} = {}, storeSessionFilter, tableKey } = this.props;
        const { filters, pagination } = parseURLSearch(search);

        const searchChanged = this.isSearchChanged(prevProps);
        const { globalFilterContext: { globalFilterHash: prevGlobalFilterHash } } = prevProps
        const { globalFilterContext: { globalFilterHash } } = this.props;
        if (!_.isEqual(prevGlobalFilterHash, globalFilterHash)) {
            this.resetFilters();
            this.fetchFilters();
        } else if (searchChanged) {
            this.fetchData();
            if (tableKey) {
                const sessionStorageData = {
                    pageSize: pagination.size,
                };
                if(storeSessionFilter === true){
                    sessionStorageData.filters = filters;
                }
                setTemporarySessionStorage(tableKey, sessionStorageData);
            }
        }
    }
    componentWillUnmount(){
        if(typeof this.cancelApi === "function"){
            this.cancelApi();
        }
        if(typeof this.cancelFilterApi === "function"){
            this.cancelFilterApi();
        }
    }
    async fetchFilters(){
        const {filtersApi} = this.props;
        if(!filtersApi){
            return;
        }
        let filtersValues = {};
        try {
            const {promise, cancel} = filtersApi();
            if(!cancel){
                throw new Error("Filters API needs to be wrapped with cancellable.");
            }
            if (_.isFunction(this.cancelFilterApi)) {
                this.cancelFilterApi();
            }
            this.cancelFilterApi = cancel;
            filtersValues = await promise;
        } catch (e) {
            console.log(e);
        } finally {
            this.setState({filtersValues});
        }
    }
    async fetchData(){
        const {api, multiSort, expandFirstRowByDefault = false } = this.props;
        const {cancelApi} = this;

        /**
         * Cancelling previous API to prevent race condition, 
         * where the latest api loads early than the previous one.
         */
        if(typeof cancelApi === "function"){
            cancelApi();
            this.cancelApi = null;
        }

        const {pagination, filters, query} = this.getFilteredData();
        const [sortColumn, sortOrder] = (pagination.sort || "").split(",");
        let order;
        let errorMessage = false;
        if(sortOrder === "ascend"){            
            order = 'asc'
        } else if(sortOrder === "descend"){
            order = 'desc'
        }
        const paginationObj = { ...pagination, ...{ sortOrder: order, sortColumn }};
        if (multiSort) {
            paginationObj.sortColumns = parseMultiSort(paginationObj.sort)
            paginationObj.sortColumns = paginationObj.sortColumns.map((entry) => {
                return {
                    ...entry,
                    direction: entry.direction === "ascend" ? "asc" : "desc"
                }
            })
        } else {
            _.assign(paginationObj, { ...paginationObj.pagination, sort: sortColumn ? `${sortColumn||""},${order||""}` : undefined})
            // delete paginationObj.sortColumn;
        }
        let promise;
        // checked all the pages with enabling sort property, working fine with the below conditions
        const apiRequest = api({ ...paginationObj, filters: { ...filters } });
        if(apiRequest instanceof Promise) {
            promise = apiRequest;
            this.cancelApi = makeCancellablePromise(promise).cancel;
        } else {
            promise = apiRequest.promise;
            this.cancelApi = apiRequest.cancel;
        }

        this.setState({
            loading: true,
            pagination,
            paginationObj: {
                pageSize: pagination.size,
                current: pagination.page + 1
            },
            errorMessage
        });
        let dataSource = [], totalElements = 0;
        try {
            const data = await promise;
            
            dataSource =  data.content || (this.props.getData && this.props.getData(data)) || [];

            // 
            _.each(dataSource, (d, i) => {
                d.__rowKey__ = `${d.id}_${i}`
            });
            // 

            totalElements = data.totalElements || data.totalCount || dataSource?.length || 0;
        } catch (e) {
            if (getErrorMessage(e) === MAX_DATA_ERROR_MSG) {
                errorMessage = true;
            }
            console.error(e);
        } finally {
            let expandedValue = expandFirstRowByDefault ? [] : this.state.expandedValue;
            if (expandFirstRowByDefault && !_.isEmpty(dataSource)) {
                expandedValue = [dataSource[0].id]
            }
            this.setState({
                dataSource,
                totalElements,
                loading: false,
                expandedValue,
                errorMessage
            });
        }
        if(this.props.updateActiveCollapsesToolConfigs && isFunction(this.props.updateActiveCollapsesToolConfigs)){
            this.props.updateActiveCollapsesToolConfigs(this.state.dataSource);
        }
    }

    getFilterProps({
        filterKey,
        filterLabelFormatter,
        onlySearch,
        filterType,
        nullFilterValue,
        showNameInFilter = false,
        isMultipleValueSupported = false,
        sortOptions = true,
        showHelpText = false,
        filterCompareLabel,
        allowFutureDates = false,
    }) {
        if(!filterKey){
            return null;
        }
        const { filtersValues } = this.state;
        const { getNameList } = this.props.globalUserListContext;
        
        return getFilterProps({
            dataIndex: filterKey,
            filters: _.get(filtersValues, filterKey),
            filterLabelFormatter,
            noFilterFunction: true,
            onlySearch,
            filterType,
            nullFilterValue,
            showHelpText,
            isMultipleValueSupported,
            getNameList: showNameInFilter ? getNameList : _.noop(),
            sortOptions,
            filterCompareLabel,
            allowFutureDates
        });
    }

    handleSwitch(e) {
        const { dataSource = [] } = this.state;
        if (e) {
            this.setState({
                expandedValue: dataSource.map(data => isFunction(this.props.rowKey) ? this.props.rowKey(data) : data[this.props.rowKey] || data?.name)
            })
        }
        else {
            this.setState({
                expandedValue: []
            })
        }
    }

    onExpandRow(expanded, record) {
        let keys = cloneDeep(this.state.expandedValue);

        if(expanded) {
            keys.push(isFunction(this.props.rowKey) ? this.props.rowKey(record) : record[this.props.rowKey] || record?.name)
        } else {
            const key = isFunction(this.props.rowKey) ? this.props.rowKey(record) : record[this.props.rowKey] || record?.name;
            keys = remove(keys, (k) => k !== key);
        }
        this.setState({
            expandedValue: keys
        })
    }

    onSearchBox = _.debounce((search, searchKey) => {
        const {filters, pagination} = this.getFilteredData()
        filters[searchKey] = search
        pagination.page = 0;
        this.updateTableChange({
            pagination,
            filters
        });
    }, 500)

    clearSearch = (searchKey) => {
        const {filters} = this.getFilteredData()
        const newFilters = _.omit(filters, searchKey);
        this.updateTableChange({
            filters:newFilters
        })
   }

    getFilterPropsData = (filterKey, column) => {
        return {
            ...column,
            filterKey: filterKey || column.dataIndex
        }
    }

    getSortEnableActiveColumns = () => {
        const activeColumns = this.getActiveColumns();
        return activeColumns.filter(active => {
            return this.props.columns.findIndex(col => {
                const dataIndex = getDataIndex(col);
                return col.showSort && active.field === dataIndex;
            }) !== -1
        })
    }

    redirectToFirstPage = () => {
        const {pagination,  filters, query, savedSearch } = this.getFilteredData();
        this.updateTableChange({
            pagination: {...DEFAULT_PAGINATION, size: pagination.size, sort: pagination.sort },
            filters,
            query,
            savedSearch
        })
    }

    prepareColumns(columns, pagination, filters){
        const aqlEnabled = filters && !_.isUndefined(filters.aql);
        const { multiSort } = this.props;
        const [sortColumn, sortOrder] = (pagination.sort || "").split(",");
        return _.map(columns, ({showSort, showFilter, filterKey, filterDropdown, ...column}, _index) => {
            const props = this.getFilterPropsData(filterKey, column);
            const obj = {
                ...column,
                // moved this up because it override passed filterDropdown from getFilter props
                ...(showFilter && !aqlEnabled ? this.getFilterProps(props) : {}),
                ...(filterDropdown && !aqlEnabled ? {filterDropdown} : {}),
                filteredValue: filters && (filters[filterKey || column.dataIndex ] || null),
                sorter: showSort && !aqlEnabled && _.noop,
                sortOrder: (sortColumn === column.dataIndex || sortColumn === column.key) && sortOrder,
            }
            if(column.children){
                obj.children = this.prepareColumns(column.children, pagination, filters);
            }
            if (multiSort && !_.isEmpty(pagination?.sort)) {
                const dataIndex = getDataIndex(column);
                const parsedMultiSort = parseMultiSort(pagination.sort)
                const mIndex = _.findIndex(parsedMultiSort, (mSort) => mSort.property === dataIndex);
                if (mIndex !== -1) {
                    obj.sortOrder = `${parsedMultiSort[mIndex].direction}`;
                }
                if (showSort && !aqlEnabled) {
                    obj.sorter = { multiple: _index + 1 };
                }
            }
            return obj;
        })
    }

    applyAQL(){
        const parsedUrl = parseURLSearch(this.props.location.search);
        parsedUrl.filters.aql = [this.aqlTextAreaRef.current.state.value];
        updateURLSearch(this.props.history, parsedUrl);
    }

    toggleAQL(){
        const parsedUrl = parseURLSearch(this.props.location.search);
        const isBasicFilter = _.isUndefined(parsedUrl.filters.aql);
        if (isBasicFilter){
            parsedUrl.filters = {
                aql: []
            }
        } else {
            delete parsedUrl.filters.aql;
        }
        updateURLSearch(this.props.history, parsedUrl);
    }

    render(){
        const {totalElements, dataSource, loading, paginationComponentSize, query, errorMessage } = this.state;
        const {extras = false, enableScroll, location, sharableLink, title, searchKey, searchPlaceholder = '', rowKey, fixedColumnRight = true, tableKey, showAdvanceFilter = false, multiSort, showTotal, useCustomPagination= false, paginationPosition, paginationAlignClassName, showRestFilter, featureFlags, pageSizeOptions, ...restProps} = this.props;
        const activeOptionalColumns = restProps.userPreferencesContext.getActiveOptionalColumns(tableKey);
        const { allowAQL, hideMultiSortButton } = this.props;
        const { filters, ...restFilters } = this.getFilteredData();
        const aqlEnabled = filters && !_.isUndefined(filters.aql);
        const pagination = _.assign({}, this.state.pagination, restFilters.pagination)
        const [sortColumn] = (pagination.sort || "").split(",");
        const extrafilterColumns = restProps.extraFilter ? restProps.extraFilter.map(({showSort, showFilter, filterKey, ...column}) => {
            const props = this.getFilterPropsData(filterKey, column);
            return {
                ...this.getFilterProps(props),
                ...column,
                filteredValue: filters[filterKey || column.dataIndex] || null,
            }
        }): []
        const _allColumns = this.prepareColumns(restProps.columns, pagination, filters);
        const savedColumns = tableKey
            ? restProps.userPreferencesContext
                .getSavedColumnPreferences(tableKey, _allColumns)
                .filter(
                    (c) =>
                        !c.optional ||
                        activeOptionalColumns.indexOf(getDataIndex(c)) !== -1
                )
            : _allColumns;
        const _columns = restProps.userPreferencesContext.getColumnOrder(tableKey, savedColumns, 'key');

        let tableScrollProp;
        if(enableScroll){
            if(_columns[0]){
                _columns[0].fixed = "left";
            }
            // Fixing Notes Column in ToolConfig Listing Page
            if(fixedColumnRight && _columns.length > 1 && _columns[_columns.length-2].key === "notes"){
                _columns[_columns.length - 2].fixed = "right";
            }
            if(fixedColumnRight && _columns.length !== 1 && _columns[_columns.length - 1]){
                _columns[_columns.length - 1].fixed = "right";
            }
            tableScrollProp = { x: restProps.scrollWidth || (MIN_SCREEN_WIDTH - FULL_MENU_WIDTH - BASE_MARGIN * 4) };
        }
        const columnOptions = this.renderColumnOptions();
        let newFilter = this.props.noProductSubProductEnvFilter ? omit(filters, ["environmentName", "product", "subProduct"]) : filters
        newFilter = omit(newFilter, this.props.ignoreFiltersOnReset);
        const reset = !_.isEmpty(newFilter) || sortColumn || (pagination?.size && pagination.size !== 10) || (multiSort && !_.isEmpty(pagination.sort)) || !_.isEmpty(query);
        const _localProps = errorMessage ? { emptyText: <>{ MAX_DATA_MSG } <Button className="m-0 p-0" type="link" onClick={this.redirectToFirstPage}> Go to first Page.</Button></>} : this.props.locale;
        return (
            <Row gutter={BASE_GUTTER} className="table-container-evolved">
                {/* Do not use title & search both togather */}
                {
                    <Col md={10} sm={24}>
                        {title ? (
                            _.isString(title) ? (
                                <Typography.Title className="m-b-0" level={5}>
                                {title}
                                </Typography.Title>
                            ) : (
                                title
                            )
                        ) : null}
                        {searchKey && <Input autoFocus suffix={this.state.searchBoxText ? <CloseIcon onClick={() => this.clearSearch(searchKey)} /> : <SearchIcon /> } placeholder={searchPlaceholder} onChange={(e) => {this.setState({searchBoxText: e.currentTarget.value}); this.onSearchBox(e.currentTarget.value, searchKey)}} value={this.state.searchBoxText} className='m-t-xs' style={{width: 480, zIndex: 1}} />}
                    </Col>
                }
                <Col md={14} sm={24} className="d-flex justify-content-flex-end">
                    <Space size={BASE_PADDING} className="table-extras">
                        {showTotal && <span className="text-bold">Total Records: {formatNumber({count:totalElements, onlyString: true })}</span>}
                        {this.props.expandable && dataSource.length && !this.props.hideExpandAll ? <>Expand All <Switch  size="small" checked={this.state.expandedValue.length === dataSource.length}  onClick={this.handleSwitch}/></> : null}
                        {extras}
                        {extras && <Divider type="vertical" className="m-0" />}
                        {sharableLink && <ShareIt />}
                        {sharableLink && <Divider type="vertical" className="m-0" />}
                        {showRestFilter &&
                        <>
                            <Tooltip title="Reset Filter and Sorting" placement="topRight">
                                <ResetFilterIcon onClick={reset ? this.resetFilters : null} className={ !reset ? 'disabled clickable' : "clickable"}/>
                            </Tooltip>
                            {tableKey && <Divider type="vertical" className="m-0" />}
                            </>}
                        {!_.isUndefined(tableKey) && columnOptions}
                        {/*
                            Will re-enable this pagination when we will start have large set data,
                        */}
                        {/* <Pagination
                            current={page}
                            total={filteredData.length}
                            onChange={this.onExternalPaginationChange}
                        /> */}
                    </Space>
                </Col>
                {
                    (showAdvanceFilter || allowAQL || (multiSort && !hideMultiSortButton))
                    ?
                    <Col span={24} className="d-flex">
                        <div className="flex-1">
                            {
                                showAdvanceFilter && 
                                (
                                    aqlEnabled
                                    ?
                                    <div className="d-flex">
                                        <Input.TextArea className="flex-1" ref={this.aqlTextAreaRef} defaultValue={filters.aql[0]} rows={1} />
                                        <Button type="link" className="border-right" onClick={this.applyAQL}>Search</Button>
                                    </div>
                                    :
                                    <FilterBar columns={_.uniqBy([...extrafilterColumns,..._allColumns], getDataIndex)} />
                                )
                            }
                        </div>
                        <div>
                            {
                                allowAQL && <Button type="link" className="border-right" onClick={this.toggleAQL}>{aqlEnabled ? "Switch to basic filters" : "Switch to AQL"}</Button>
                            }
                        </div>
                        <div>
                            {
                                multiSort && !hideMultiSortButton && <MultiSorting activeColumns={this.getSortEnableActiveColumns()}/>
                            }
                        </div>
                    </Col>
                    :
                    null
                }
                <Col sm={24} className="table-col">
                    <Table
                        {...restProps}
                        sticky={this.props.sticky ? { offsetHeader: 0 } : false}
                        size={"small"}
                        columns={_columns}
                        dataSource={dataSource}
                        locale={_localProps}
                        rowKey={rowKey || (record => record.id)}
                        pagination={(totalElements > (this.props.defaultPageSize || 10) && !useCustomPagination) ? {
                            pageSizeOptions: pageSizeOptions,
                            total: totalElements,
                            current: pagination.page + 1,
                            size: paginationComponentSize || "default", 
                            pageSize: pagination.size, 
                            hideOnSinglePage: !this.props.showSizeChanger, 
                            className: classNames("ant-table-pagination ant-table-pagination-right",  {"m-b-0": !paginationAlignClassName}, paginationAlignClassName),
                            showSizeChanger: this.props.showSizeChanger,
                            position: [paginationPosition],
                        } : false}
                        expandable={
                            restProps.expandable ? {
                                ...restProps.expandable,
                                expandedRowKeys: this.state.expandedValue,
                                // Show icons only if row is expandable
                                expandIcon:  ({ expanded, onExpand, record, expandable }) => {
                                    return expandable ? 
                                                expanded  ? (
                                                    <DownIcon onClick={e => onExpand(record, e)} className="clickable" size="lg" color="#8E8E8E"/>
                                                ) : (
                                                    <RightIcon onClick={e => onExpand(record, e)} className="clickable"  size="lg" color="#8E8E8E" />
                                                ) 
                                            : null
                                },
                                onExpand: this.onExpandRow
                            } : {}
                        }
                        onChange={this.onChangeTable}
                        loading={{spinning: loading, indicator: <LoadingIcon spin={false} />}}
                        scroll={tableScrollProp}
                        rowClassName={(record, index) =>
                            index % 2 !== 0 ? "table-row-even" : "table-row-odd"
                        }
                    />
                </Col>
                {useCustomPagination && <Col sm={24} className="m-0 p-0 table-col">
                    <Pagination
                        total={totalElements}
                        pageSize={pagination.size}
                        onPageChange={this.onPageChange}
                        current={pagination.page + 1}
                        showSizeChanger={this.props.showSizeChanger}
                        size={paginationComponentSize || "default"}
                        hideOnSinglePage={!this.props.showSizeChanger} 
                    />
                </Col>}
            </Row>
        )
    }
}

export const TableContainerEvolvedWithoutRouter = withFeatureFlags(withUserPreferencesContext(withGlobalSettingsContext(withGlobalFilterContext(withGlobalUserListContext(TableContainerEvolved)))));
export default withRouter(TableContainerEvolvedWithoutRouter);